import { createSelector } from 'reselect';
import { getTeacherReserveInfo } from 'platform-components/src/components/app-factory/selectors';

export const getTeacherReserveProgressPoints = createSelector(
    [getTeacherReserveInfo],
    (data) => data?.progressPoints ?? []
);

export const getTeacherReservePromocodesPrefixes = createSelector(
    [getTeacherReserveInfo],
    (data) => data?.promocodesPrefixes ?? []
);
